import React from "react";
import Summary from "./Summary";
import ProductReview from "./ProductReview";
import StockManagement from "./StockManagement";
import TopSales from "../sales/TopSales";
import Orders from "../sales/Orders";
import queryString from "query-string";
import AddStock from "./AddStock";
import logo from "../../images/logo.png";
import { Helmet } from "react-helmet/es/Helmet";

class Home extends React.Component {
  render() {
    let edit = false;
    let add = false;
    let product = null;
    let params = queryString.parse(this.props.location.search);
    let urlState = this.props.location.state;
    console.log(params, urlState);

    if (params.edit) {
      edit = true;
    }

    if (params.add) {
      add = true;
    }

    if (urlState) {
      if (urlState.edit) {
        edit = true;
      }

      if (urlState.add) {
        add = true;
      }

      if (urlState.product) {
        product = urlState.product;
      }
    }

    return (
      <div>
        <Helmet>
          <link rel="icon" href={logo} />
          <title>Dashboard | VehShop</title>
        </Helmet>
        <div>
          <Summary focus={this.props.focus} focusObj={this.props.focusObj} />
        </div>

        <div className="columns">
          <div className="column is-4">
            {!edit ? (
              <ProductReview />
            ) : (
              <StockManagement
                product={product}
                focus={this.props.focus}
                focusObj={this.props.focusObj}
              />
            )}
          </div>
          <div className="column is-1"></div>
          <div className="column is-7">
            <TopSales focus={this.props.focus} focusObj={this.props.focusObj} />
          </div>
        </div>

        <div className="columns">
          <div className="column is-12">
            <Orders focus={this.props.focus} focusObj={this.props.focusObj} />
          </div>
        </div>

        {add ? (
          <div>
            <AddStock
              product={product}
              focus={this.props.focus}
              focusObj={this.props.focusObj}
            />
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Home;
